<script setup lang="ts">

import type { Animation } from '../Types/Animation';

type Props =
{ 
    src: string,
    animation?: Animation,
    flip?: boolean,
    border?: boolean,
    imageClass?: string,
    floorShadow?: boolean
}

const { src, flip = false, border = false, animation = 'fade', floorShadow = false } = defineProps<Props>();

</script>

<template>

    <div class="w-full grid grid-cols-1 lg:grid-cols-9 items-center gap-12">

        <div class="w-full mx-auto col-span-1 lg:col-span-4 items-center justify-center"
            :class="flip ? 'order-1 2xl:-translate-x-10' : '2xl:translate-x-8'">
            <Image 
                :src="src" 
                :image-class="imageClass"
                :border="border"
                :floor-shadow="floorShadow"
            />
        </div>

        <Animated :animation="animation" class="col-span-1 lg:col-span-5">
            <div class="text-base lg:text-lg xl:text-xl 2xl:text-2xl 3xl:text-3xl font-semibold mx-auto"
                :class="flip ? 'xl:pl-16 2xl:pl-8 2xl:pr-16' : 'xl:pr-16 2xl:pl-20 2xl:pr-4'">
                <slot>
                </slot>
            </div>
        </Animated>

    </div>

</template>